import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSONWith} from '../../platform/functional-fetch-wrapper'
import type {ImportIssueFieldsRequest, ImportIssueFieldsResponse} from './contracts/api'

export async function apiImportIssueFields(body: ImportIssueFieldsRequest): Promise<ImportIssueFieldsResponse> {
  const apiData = getApiMetadata('memex-import-issue-fields-api-data')
  const {data} = await fetchJSONWith<ImportIssueFieldsResponse>(apiData.url, {
    method: 'POST',
    body,
  })

  return data
}
